const userManagementActionTypes = {
  GET_USER_LIST: "GET_USER_LIST",
  GET_USER_LIST_SUCCESS: "GET_USER_LIST_SUCCESS",
  GET_USER_LIST_FAIL: "GET_USER_LIST_FAIL",
};

export default userManagementActionTypes;
